import * as API from "./";

export default {
  // 自动登录
  auto_login: params => {
    return API.GET("API/AUTH/login", params);
  },
  // 其他用户登录
  user_login: params => {
    return API.POST("API/AUTH/login", params);
  },
  // 查询交付列表
  sel_del: params => {
    return API.GET("/api/visualize/me/", params);
  },
  // 查询OSS列表
  sel_oss: params => {
    return API.POST("API/USER/func016/", params);
  },
  // 下载确认
  download_check: params => {
    return API.POST("API/USER/func003/", params);
  },
  // 下载文件
  download_oss: params => {
    return API.GET_download1(
      `API/USER/func004/?file_collections=${JSON.stringify(params)}`
    );
  },
  logout: params => {
    return API.POST("API/logout", params);
  },
  client_logout: params => {
    return API.GET("API/AUTH/logout", params);
  },
  reset_password: params => {
    return API.POST("API/ADMIN/reset_password/", params);
  },

  // 任务labels查询
  get_task_label: params => {
    return API.GET("/api/label/labels_by_type/", params);
  },
  // 任务列表查询
  get_task_list: params => {
    return API.GET("/api/task-template/", params);
  },
  // tool_name搜索
  get_search_tool: params => {
    return API.GET("/api/task-template/", params);
  },
  // label搜索任务
  get_label_search_tool: params => {
    return API.GET(`/api/task-template/`, params);
  },
  // 任务参数查询
  get_tool_param: params => {
    return API.GET(`/api/task-template/${params.tool}/`,params.param);
  },
  // 任务数据分类查询
  get_tool_sub_type: params => {
    return API.GET(`/api/visualize/${params}/meta/`);
  },
  // 查询用户余额
  get_balance: params => {
    return API.GET("API/USER/func005/", params);
  },
  // 任务使用提交
  tool_confirm: params => {
    return API.POST("/api/single-analysis-task/", params);
  },
  // 获取工具结果
  get_result_data: params => {
    return API.GET("/api/single-analysis-task/", params);
  },
  // 下载结果
  download_result: params => {
    return API.GET_download1(`/api/single-analysis-task/${params}/download/`);
  },
  // 工具添加
  tool_add: params => {
    return API.POST("/api/tool/", params);
  },
  // 工具修改
  tool_update: params => {
    return API.PUT(`/api/tool/${params.id}/`, params.param);
  },
  // 获取工具详情
  get_tool_info: params => {
    return API.GET(`/api/tool/${params}/`);
  },
  // 生成任务模板
  created_task: params => {
    return API.POST("/api/task-template/", params);
  },
  // 获取工具列表
  get_tools: params => {
    return API.GET("/api/tool/", params);
  }
};



// WEBPACK FOOTER //
// ./src/services/user.js